import { render, staticRenderFns } from "./CommonTextBoxStep.vue?vue&type=template&id=4fdb78c2&scoped=true"
import script from "./CommonTextBoxStep.vue?vue&type=script&lang=js"
export * from "./CommonTextBoxStep.vue?vue&type=script&lang=js"
import style0 from "./CommonTextBoxStep.vue?vue&type=style&index=0&id=4fdb78c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb78c2",
  null
  
)

export default component.exports